/* -------------------------------------------------------------------------------------------------
 * IAutodeskSSOModel
 * -----------------------------------------------------------------------------------------------*/

export interface IAutodeskSSOModel {
    _id: string;
    client: string;
    user: string;
    createdAt: string;
}

/* -------------------------------------------------------------------------------------------------
 * AutodeskSSOModel
 * -----------------------------------------------------------------------------------------------*/
export class AutodeskSSOModel {
    _id: string;
    client: string;
    user: string;
    createdAt: string;

    constructor(data: Partial<IAutodeskSSOModel>) {
        this._id = data._id ?? '';
        this.client = data.client ?? '';
        this.user = data.user ?? '';
        this.createdAt = data.createdAt ?? '';
    }

    static fromObject(data: Partial<IAutodeskSSOModel>): AutodeskSSOModel {
        const model = new AutodeskSSOModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IAutodeskSSOModel>[]): AutodeskSSOModel[] {
        return data.map((row) => AutodeskSSOModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IAutodeskSSOModel>): AutodeskSSOModel {
        const model = new AutodeskSSOModel(data);

        return model;
    }

    toObject(): IAutodeskSSOModel {
        const data: IAutodeskSSOModel = {
            _id: this._id,
            client: this.client,
            user: this.user,
            createdAt: this.createdAt,
        };

        return data;
    }
}
